import { render, staticRenderFns } from "./heart.vue?vue&type=template&id=fd1bc7a0&scoped=true&"
import script from "./heart.vue?vue&type=script&lang=js&"
export * from "./heart.vue?vue&type=script&lang=js&"
import style0 from "./heart.vue?vue&type=style&index=0&id=fd1bc7a0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1bc7a0",
  null
  
)

export default component.exports